import {createSlice} from "@reduxjs/toolkit"

const CompanyLevelTariffTypeSlice = createSlice({
    name: "companyLevelTariff",
    initialState: {
        companyId: "",
        companyName: "",
        companyType: "",
        tariffType: <any>{},
    },
    reducers: {
        redirectCompanyLevelTariff: (state, action) => {
            state.companyId = action.payload.companyId
            state.companyName = action.payload.companyName
            state.companyType = action.payload.companyType
            state.tariffType = action.payload.tariffType
        },
    },
})

export const {redirectCompanyLevelTariff} = CompanyLevelTariffTypeSlice.actions
export default CompanyLevelTariffTypeSlice.reducer
